// extracted by mini-css-extract-plugin
export default {"container":"Zd9krJ","mobile-items":"KFEmqq","horizontal-items":"nFTYSh","errorBlock":"FYFEtr"};